module.exports = __webpack_public_path__ + "img/circle_active_large.c541617c.png";